import React from "react";
import Image from "next/image";
import Link from "next/link";
import useRouter from "domains/navigation/hooks/useRouter";
import Button from "domains/ui/components/Button";
import WithGradientEffect from "domains/ui/components/WithGradientEffect";

import { Flex, Text, VStack } from "@chakra-ui/react";

export interface AssetsGalleryEmptyStateProps {
  modelId?: string;
  withoutGenerateButton?: boolean;
}

export default function AssetsGalleryEmptyState({
  modelId,
  withoutGenerateButton = false,
}: AssetsGalleryEmptyStateProps) {
  const router = useRouter();

  const isOnLoraCatalog = router.pathname.includes("/compose");
  return (
    <Flex data-testid="asset-gallery-empty-state">
      <VStack mt={4}>
        <WithGradientEffect>
          <Image
            src="/ui/model-empty-state.svg"
            alt="Empty state"
            width={200}
            height={200}
          />
        </WithGradientEffect>
        <VStack pt={3} pb={5}>
          <Text size="title.md">No Images Available</Text>
        </VStack>

        {!withoutGenerateButton && (
          <Link
            href={{
              pathname: "/images/new",
              query: modelId
                ? {
                    modelId,
                  }
                : {},
            }}
            target={isOnLoraCatalog ? "_blank" : undefined}
          >
            <Button variant="secondary">Start Generating Now</Button>
          </Link>
        )}
      </VStack>
    </Flex>
  );
}
